export const APP_CONFIG = {
    appTitle: 'FluidSys',
    appVersion: "0.0.1",
    dbVersion: "0.0.1",
    contentContactURL: "https://inside.chevron.com",
    technicalContactURL: "https://chevron.service-now.com"
};
